export const APPOINTMENT_STATUS_LABEL: Record<string, string> = {
  agendado: "Agendado",
  confirmado: "Confirmado",
  em_atendimento: "Em atendimento",
  finalizado: "Finalizado",
  pago: "Pago",
  cancelado: "Cancelado",
  faltou: "Faltou",
};

export const APPOINTMENT_STATUS_BADGE: Record<string, string> = {
  agendado: "bg-slate-500 text-white",
  confirmado: "bg-blue-500 text-white",
  em_atendimento: "bg-amber-500 text-white",
  finalizado: "bg-teal-500 text-white",
  pago: "bg-emerald-700 text-white",
  cancelado: "bg-red-600 text-white",
  faltou: "bg-slate-900 text-white",
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  DINHEIRO: "Dinheiro",
  CARTAO_DEBITO: "Débito",
  CARTAO_CREDITO: "Crédito",
  PIX: "PIX",
  A_RECEBER: "A receber",
};

export const formatCurrency = (value?: number | null) =>
  Number(value ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/**
 * Badge CSS classes keyed by appointment type behavior (or legacy type slug).
 * Used for inline icons in timeline/history components.
 */
export const APPOINTMENT_TYPE_BADGE: Record<string, string> = {
  padrao: "bg-blue-500 text-white",
  consulta: "bg-blue-500 text-white",
  cirurgia: "bg-red-500 text-white",
  retorno: "bg-yellow-500 text-white",
  aplicacao: "bg-indigo-500 text-white",
  banho_tosa: "bg-green-500 text-white",
  vacina: "bg-indigo-500 text-white",
  outro: "bg-purple-500 text-white",
};
